import { LanguageRegions as LR } from './gen';

/**
 * Converts a browser locale string to the corresponding LanguageRegion enum value.
 * If no match is found, it defaults to EN_US.
 */
export function convertBrowserLocaleToLanguageRegion(locale: string): LR.LanguageRegion {
  if (!locale) {
    return LR.LanguageRegion.EN_US;
  }

  // Normalize the locale string to match our enum format
  const normalizedLocale = locale.replace('-', '_').toUpperCase();

  // Try to find a direct match in the enum
  const enumKey = `LANGUAGE_REGION_${normalizedLocale}` as keyof typeof LR.LanguageRegion;
  if (LR.LanguageRegion[enumKey] !== undefined) {
    return LR.LanguageRegion[enumKey];
  }

  // Map of specific region codes to their corresponding LanguageRegion values
  const regionMap: Record<string, LR.LanguageRegion> = {
    'EN_GB': LR.LanguageRegion.EN_GB,
    'EN_CA': LR.LanguageRegion.EN_CA,
    'EN_AU': LR.LanguageRegion.EN_AU,
    'EN_IN': LR.LanguageRegion.EN_IN,
    'ZH_TW': LR.LanguageRegion.ZH_TW,
    'ZH_HK': LR.LanguageRegion.ZH_HK,
    'ZH_SG': LR.LanguageRegion.ZH_SG,
    'DE_AT': LR.LanguageRegion.DE_AT,
    'DE_CH': LR.LanguageRegion.DE_CH,
    'DE_LU': LR.LanguageRegion.DE_LU,
    'ES_MX': LR.LanguageRegion.ES_MX,
    'ES_AR': LR.LanguageRegion.ES_AR,
    'ES_CO': LR.LanguageRegion.ES_CO,
    'FR_CA': LR.LanguageRegion.FR_CA,
    'FR_BE': LR.LanguageRegion.FR_BE,
    'FR_CH': LR.LanguageRegion.FR_CH,
    'PT_PT': LR.LanguageRegion.PT_PT,
    'LEET': LR.LanguageRegion.LEET,
    'leet': LR.LanguageRegion.LEET,
  };

  // Check if we have a specific region mapping
  if (regionMap[normalizedLocale]) {
    return regionMap[normalizedLocale];
  }

  // If no direct match, try to match just the language part
  const languagePart = normalizedLocale.split('_')[0] || '';

  // Map of language codes to their default regions
  const defaultRegions: Record<string, LR.LanguageRegion> = {
    'EN': LR.LanguageRegion.EN_US,
    'ZH': LR.LanguageRegion.ZH_CN,
    'DE': LR.LanguageRegion.DE_DE,
    'ES': LR.LanguageRegion.ES_ES,
    'FR': LR.LanguageRegion.FR_FR,
    'JA': LR.LanguageRegion.JA_JP,
    'KO': LR.LanguageRegion.KO_KR,
    'RU': LR.LanguageRegion.RU_RU,
    'PT': LR.LanguageRegion.PT_BR,
    'AR': LR.LanguageRegion.AR_SA,
    'HI': LR.LanguageRegion.HI_IN,
    'IT': LR.LanguageRegion.IT_IT,
    'NL': LR.LanguageRegion.NL_NL,
    'SV': LR.LanguageRegion.SV_SE,
  };

  // Return the default region for the language if it exists
  return defaultRegions[languagePart] || LR.LanguageRegion.EN_US;
}
